<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col>
        <v-tabs
          v-model="tab"
          dark
          class="rounded-lg"
          dense
          background-color="primary"
          active-class="tab-active"
          slider-color="#ffbc00"
        >
          <v-tab class="font-weight-black" @click="getConfigCurriculo()"
            >CurrÍculo Nacional</v-tab
          >
          <v-tab class="font-weight-black" @click="getAgregarCompetencia()"
            >Competencias</v-tab
          >
          <v-tab class="font-weight-black" @click="getAsignarCompetencia()"
            >Asociar competencias</v-tab
          >
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item class="py-4">
            <!-- Componente configuracion Curriculo por pais -->
            <component
              :is="compConfigCurriculo"
              :estadoComp="estadoConfigCurriculo"
              :parametros="parametroConfigCurriculo"
            >
            </component>
          </v-tab-item>

          <v-tab-item class="py-4">
            <!-- Componente Asociar Competencias Capacidades y Desempeño -->
            <component
              :is="compAgregarCompetencia"
              :estadoComp="estadoAgregarCompetencia"
              :parametros="parametroAgregarCompetencia"
            >
            </component>
          </v-tab-item>

          <v-tab-item class="py-4">
            <!-- Componente escala evaluativa -->
            <component
              :is="compAsignarCompetencia"
              :estadoComp="estadoAsignarCompetencia"
              :parametros="parametroAsignarCompetencia"
            >
            </component>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import axios from '../../../helpers/axios'
import { mapMutations, mapGetters, mapActions } from "vuex";

import ConfigCurriculo from "@/views/Manager/Competencia/components/ConfigCurriculo.vue";
import AgregarCompetencia from "@/views/Manager/Competencia/components/AgregarCompetencia.vue";
import AsignarCompetencia from "@/views/Manager/Competencia/components/AsignarCompetencia.vue";

export default {
  name: "configCompetencia",

  components: {
    ConfigCurriculo,
    AgregarCompetencia,
    AsignarCompetencia,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 77, id_modulo: 4 }, //sud_modulo y modulo
    tab: 0,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    // componente configuración de Curriculo
    compConfigCurriculo: null,
    estadoConfigCurriculo: false,
    parametroConfigCurriculo: {},

    // componente Agregar Competencias
    compAgregarCompetencia: null,
    estadoAgregarCompetencia: false,
    parametroAgregarCompetencia: {},

    // componente Asignar Competencias
    compAsignarCompetencia: null,
    estadoAsignarCompetencia: false,
    parametroAsignarCompetencia: {},
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    loadMain() {
      this.getConfigCurriculo();
    },

    // componente nota numerica
    async getConfigCurriculo() {
      await this.limpiarForm();
      this.compConfigCurriculo = "ConfigCurriculo";
      this.estadoConfigCurriculo = true;
      this.estadoAgregarCompetencia = false;
      this.estadoAsignarCompetencia = false;
      this.parametroConfigCurriculo = {};
    },

    // componente nota literal
    async getAgregarCompetencia() {
      await this.limpiarForm();
      this.parametroAgregarCompetencia = {};
      this.estadoConfigCurriculo = false;
      this.estadoAgregarCompetencia = true;
      this.estadoAsignarCompetencia = false;
      this.compAgregarCompetencia = "AgregarCompetencia";
    },

    // componente escala evaluativa
    async getAsignarCompetencia() {
      await this.limpiarForm();
      this.parametroAsignarCompetencia = {};
      this.estadoConfigCurriculo = false;
      this.estadoAgregarCompetencia = false;
      this.estadoAsignarCompetencia = true;
      this.compAsignarCompetencia = "AsignarCompetencia";
    },

    limpiarForm() {
      this.estadoConfigCurriculo = false;
      this.estadoAgregarCompetencia = false;
      this.estadoAsignarCompetencia = false;
    },
  },
};
</script>
